export const administrationAccountsSiteLocationEquipment = {
    template: require('./administration-accounts-site-location-equipment.html'),
    controller: 'AdministrationAccountsSiteLocationEquipmentController'
};
